import script from "./strike-pending.vue?vue&type=script&lang=js"
export * from "./strike-pending.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__